import { useEffect, useRef } from 'react';
import { AutoVoucherIcon } from '../../utils/svg';

const VerifyVoucher = ({
	onCancel = () => {},
	onSubmit = () => {},
	title = (
		<>
			Nilai pembelanjaan anda di bawah nilai voucher
			<br />
			apakah ingin tetap ditambahkan?
		</>
	),
}) => {
	const modalRef = useRef(null);

	// Listener untuk klik di luar modal
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (modalRef.current && !modalRef.current.contains(event.target)) {
				console.log('Clicked outside modal');
				onCancel(); // Panggil fungsi onCancel jika klik di luar modal
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [onCancel]);

	return (
		<div className='fixed inset-0 flex justify-center items-end z-50'>
			<div className='absolute inset-0 bg-black opacity-60'></div>
			<div id='voucher-warning-parent' ref={modalRef} className='relative bg-white rounded-t-lg p-4 shadow-custom border border-gray-300 w-full max-w-md transition-transform duration-300 ease-in-out'>
				<div className='flex justify-center pt-5'>
					<AutoVoucherIcon className='h-auto w-24' />
				</div>
				<div className='text-xs font-normal text-center pt-5'>{title}</div>
				<div className='pt-5 flex gap-2 px-20'>
					<button id='voucher_not_apply' className='w-full bg-white text-[var(--rose-violet)] border border-[var(--rose-violet)] font-semibold text-sm py-2' onClick={onCancel}>
						No
					</button>
					<button id='voucher_apply' className='w-full bg-[var(--rose-violet)] text-white font-normal text-sm border-0 py-2 rounded-lg' onClick={onSubmit}>
						Yes
					</button>
				</div>
			</div>
		</div>
	);
};

export default VerifyVoucher;
